import axios from "axios";

export default {
  // 注册
  register: (data) => {
    return axios
      .request({
        url: "api/organization/addOrganization",
        method: "post",
        data: data,
      })
      .then((res) => {
        return res.data;
      });
  },
  //登录
  login: (data) => {
    return axios
      .request({
        url: "api/organization/login",
        method: "post",
        data: data,
      })
      .then((res) => {
        return res.data;
      });
  },
  // 获取组织信息
  getOrganizationInfo: () => {
    return axios
      .request({
        url: "api/organization/getAllMembers",
        method: "post",
      })
      .then((res) => {
        return res.data;
      });
  },
  //添加用户
  addMember: (data) => {
    return axios
      .request({
        url: "api/organization/addMember",
        data: data,
        method: "post",
      })
      .then((res) => {
        return res.data;
      });
  },
  //修改用户
  editMember: (data) => {
    return axios
      .request({
        url: "api/organization/changeMember",
        data: data,
        method: "post",
      })
      .then((res) => {
        return res.data;
      });
  },
  //删除用户
  removeMember: (data) => {
    return axios
      .request({
        url: "api/organization/removeMember",
        data: data,
        method: "post",
      })
      .then((res) => {
        return res.data;
      });
  },
};
